import React from 'react';

import { Container } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import {
  Body2,
  LoyaltyTag,
  LoyaltyTagsContainer,
  OverFlowText,
  StyledLoyaltyIcon,
  Subtitle2,
} from '../store-card.styled';

interface StoreCardDetailsProps {
  body?: string;
  caption: string | JSX.Element | null;
  errorMessage?: JSX.Element | null;
  title?: string | null;
  inStoreLoyalty?: boolean | null;
  mobileLoyalty?: boolean | null;
}

export const StoreCardDetails: React.VFC<StoreCardDetailsProps> = ({
  body,
  caption,
  errorMessage,
  title,
  inStoreLoyalty,
  mobileLoyalty,
}) => {
  const { formatMessage } = useIntl();
  const enableLoyaltyTags = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_TAGS_STORE_LOCATOR);

  return (
    <Container overflow="hidden">
      {title ? (
        <Subtitle2>
          <OverFlowText>{title.toLowerCase()}</OverFlowText>
        </Subtitle2>
      ) : null}
      <Body2>{caption}</Body2>
      {body ? <Body2>{body}</Body2> : null}
      {enableLoyaltyTags && (
        <LoyaltyTagsContainer>
          {inStoreLoyalty ? (
            <LoyaltyTag mobile={false}>
              <StyledLoyaltyIcon />
              {formatMessage({ id: 'loyaltyStoreLocatorInStore' })}
            </LoyaltyTag>
          ) : null}
          {mobileLoyalty ? (
            <LoyaltyTag mobile={true}>
              <StyledLoyaltyIcon />
              {formatMessage({ id: 'loyaltyStoreLocatorMobile' })}
            </LoyaltyTag>
          ) : null}
        </LoyaltyTagsContainer>
      )}
      {errorMessage ? errorMessage : null}
    </Container>
  );
};
